import { Patientportal_AppointmentRequestProxyMsg } from '@/generated/graphql';
import { Alert } from 'antd';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { extractTranslation } from '../../helpers/formatters';
import { getAppointmentTypeName } from '../../helpers/utils';
import styles from './appointment-request.module.scss';

interface ReplacedRequestAlertProps {
  appointmentRequestProxy: Maybe<Patientportal_AppointmentRequestProxyMsg>;
}

export const ReplacedRequestAlert: FC<ReplacedRequestAlertProps> = ({
  appointmentRequestProxy,
}) => {
  const { formatMessage } = useIntl();

  const router = useRouter();

  const replacedRequestId = appointmentRequestProxy?.appointmentRequest?.replacedRequestId;

  const portalFacilities = appointmentRequestProxy?.portalFacilityPath?.portalFacilities;
  const facility = portalFacilities?.[0];

  const appointmentTypeName = extractTranslation(
    getAppointmentTypeName(appointmentRequestProxy?.appointmentRequest?.appointmentType),
    router.locale,
  );

  return replacedRequestId ? (
    <Alert
      className={styles.replacedRequestAlert}
      message={formatMessage({ id: 'appointment-request.changed' })}
      description={formatMessage(
        { id: 'appointment-request.changed.description' },
        { appointmentType: appointmentTypeName, facility: facility?.name },
      )}
      type="info"
      showIcon
    />
  ) : null;
};
